import { type EnumType } from '@ncoderz/superenum';

const groupKeys = {
  group_standardAllBits: 'group_standardAllBits',
  group_standardItemLead: 'group_standardItemLead',
  group_standardItemLeadInstructionHint: 'group_standardItemLeadInstructionHint',
  group_standardInstructionHint: 'group_standardInstructionHint',
  group_standardTags: 'group_standardTags',
  group_standardTagsNoItemLead: 'group_standardTagsNoItemLead',
  group_imageSource: 'group_imageSource',
  group_technicalTerm: 'group_technicalTerm',
  group_person: 'group_person',
  group_gap: 'group_gap',
  group_trueFalse: 'group_trueFalse',
  group_trueFalseInlineHighlight: 'group_trueFalseInlineHighlight',
  group_trueFalseInlineSelect: 'group_trueFalseInlineSelect',
  group_trueFalseResponses: 'group_trueFalseResponses',
  group_markConfig: 'group_markConfig',
  group_mark: 'group_mark',
  group_bookCommon: 'group_bookCommon',
  group_learningPathCommon: 'group_learningPathCommon',
  group_advertisingCommon: 'group_advertisingCommon',
  group_platformStylesCommon: 'group_platformStylesCommon',
  group_quizCommon: 'group_quizCommon',
  group_backgroundWallpaper: 'group_backgroundWallpaper',
  group_imageNoZoom: 'group_imageNoZoom',
  group_resourceBitTags: 'group_resourceBitTags',
  group_resourceCommon: 'group_resourceCommon',
  group_resourceImageCommon: 'group_resourceImageCommon',
  group_resourceImageCommonNoZoom: 'group_resourceImageCommonNoZoom',
  group_resourceAudioCommon: 'group_resourceAudioCommon',
  group_resourceVideoCommon: 'group_resourceVideoCommon',
  group_resourceIcon: 'group_resourceIcon', // Alias for image
  group_resourceImage: 'group_resourceImage',
  group_resourceImageNoZoom: 'group_resourceImageNoZoom',
  group_resourceImageEmbed: 'group_resourceImageEmbed',
  group_resourceImageLink: 'group_resourceImageLink',
  group_resourceImageResponsive: 'group_resourceImageResponsive', // Combo resource
  group_resourceImagePortrait: 'group_resourceImagePortrait',
  group_resourceImageLandscape: 'group_resourceImageLandscape',
  group_resourceAudio: 'group_resourceAudio',
  group_resourceAudioEmbed: 'group_resourceAudioEmbed',
  group_resourceAudioLink: 'group_resourceAudioLink',
  group_resourceVideo: 'group_resourceVideo',
  group_resourceVideoEmbed: 'group_resourceVideoEmbed',
  group_resourceVideoLink: 'group_resourceVideoLink',
  group_resourceStillImageFilm: 'group_resourceStillImageFilm', // Combo resource
  group_resourceStillImageFilmEmbed: 'group_resourceStillImageFilmEmbed',
  group_resourceStillImageFilmLink: 'group_resourceStillImageFilmLink',
  group_resourceArticle: 'group_resourceArticle',
  group_resourceArticleEmbed: 'group_resourceArticleEmbed',
  group_resourceArticleLink: 'group_resourceArticleLink',
  group_resourceDocument: 'group_resourceDocument',
  group_resourceDocumentEmbed: 'group_resourceDocumentEmbed',
  group_resourceDocumentLink: 'group_resourceDocumentLink',
  group_resourceDocumentDownload: 'group_resourceDocumentDownload',
  group_resourceAppLink: 'group_resourceAppLink',
  group_resourceWebsiteLink: 'group_resourceWebsiteLink',
  group_previewImages: 'group_previewImages',
  group_previewVideos: 'group_previewVideos',
} as const;

const GroupKey = groupKeys;

export type GroupKeyType = EnumType<typeof GroupKey>;

export { GroupKey, groupKeys };
